import React, { forwardRef } from "react";

const VectorSun = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => {
    return (
        <svg
            ref={ref}
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle className="vector-sun-circle" cx="50" cy="50" r="25" fill="#fddb8bff" />
            <path
                d="M50 0V20M50 80V100M0 50H20M80 50H100M14.6447 14.6447L28.7868 28.7868M71.2132 71.2132L85.3553 85.3553M14.6447 85.3553L28.7868 71.2132M71.2132 28.7868L85.3553 14.6447"
                stroke="#fddb8bff"
                strokeWidth="4"
                strokeLinecap="round"
            />
        </svg>
    );
});

export default VectorSun;

